// extracted by mini-css-extract-plugin
export default {"portfolioContainer":"PortfolioPage_portfolioContainer__3JztU","portfolioItems":"PortfolioPage_portfolioItems__o9LUs","portfolioItemDialog":"PortfolioPage_portfolioItemDialog__4UNmG"};